module.exports = __webpack_public_path__ + "static/img/6.48ef132.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/6.png
// module id = O59x
// module chunks = 0